import { AddParkingComponent } from "./add-parking/add-parking.component";
import { EditParkingComponent } from "./edit-parking/edit-parking.component";
import { ViewParkingComponent } from "./view-parking/view-parking.component";

export const ParkingModuleDeclaration = [
    AddParkingComponent,
    ViewParkingComponent,
    EditParkingComponent,
];